import { SVGProps } from 'react';
import cx from 'classnames';

import { IconEnum } from './icon.enum';

import styles from './icon.module.scss';

// MENU
import BasketTitledIcon from './icon-menu/with-title/basket';
import BuildReservTitledIcon from './icon-menu/with-title/build_res';
import ChatTitledIcon from './icon-menu/with-title/chat';
import DocsTitledIcon from './icon-menu/with-title/docs';
import FormTitledIcon from './icon-menu/with-title/form';
import IncidentTitledIcon from './icon-menu/with-title/incident';
import InfoTitledIcon from './icon-menu/with-title/info';
import WorksitePlanningTitledIcon from './icon-menu/with-title/worksite-planning';
import ProductionPlanningTitledIcon from './icon-menu/with-title/production-planning';
import QuoteTitledIcon from './icon-menu/with-title/quote';
import SavTitledIcon from './icon-menu/with-title/sav';
import TaskTitledIcon from './icon-menu/with-title/task';
import TransportTitledIcon from './icon-menu/with-title/transport';
import VtTitledIcon from './icon-menu/with-title/vt';
import WorksiteTitledIcon from './icon-menu/with-title/worksite';
import CustomerNotificationTitledIcon from './icon-menu/with-title/customer-notification';
import EmployeeTitledIcon from './icon-menu/with-title/employee_titled';

// DIVERS
import MobileIcon from './divers/mobile';
import MailIcon from './divers/mail';
import PlaceIcon from './divers/place';
import AddIcon from './divers/add';
import ArchiveIcon from './divers/archive';
import ArrowBackIosIcon from './divers/arrow-back-ios';
import ArrowDropDownIcon from './divers/arrow-drop-down';
import ArrowDropUpIcon from './divers/arrow-drop-up';
import ArrowForwardIosRoundedIcon from './divers/arrow-forward-ios-rounded';
import AttachFileIcon from './divers/attach-file';
import AutorenewIcon from './divers/auto-renew';
import BuildIcon from './divers/build';
import CastConnectedIcon from './divers/cast-connected';
import ChangeUserIcon from './divers/change-user-icon';
import CheckCircleIcon from './divers/check-circle';
import CheckCircleOutlineIcon from './divers/check-circle-outline';
import CheckIcon from './divers/check';
import CheckBoxOutlineBlankIcon from './divers/checkbox-outlined-blank';
import CheckBoxIcon from './divers/checkbox';
import ChevronRightIcon from './divers/chevron-right';
import CloseIcon from './divers/close';
import CreateIcon from './divers/create';
import DeleteForeverIcon from './divers/delete-forever';
import DeleteOutlineOutlinedIcon from './divers/delete-outline-outlined';
import DescriptionIcon from './divers/description';
import DeveloperBoardIcon from './divers/developer-board';
import DnsIcon from './divers/dns';
import DoneIcon from './divers/done';
import EcoIcon from './divers/eco';
import EditOutlinedIcon from './divers/edit-outlined';
import EditIcon from './divers/edit';
import ErrorOutlineIcon from './divers/error-outlined';
import EuroIcon from './divers/euro';
import EventAvailableIcon from './divers/event-available';
import ExitToAppIcon from './divers/exit-to-app';
import FastForwardIcon from './divers/fast-forward';
import FileCopyIcon from './divers/file-copy';
import FolderIcon from './divers/folder';
import FormatListBulletedIcon from './divers/format-list-bulleted';
import ForumIcon from './divers/forum';
import FullscreenIcon from './divers/full-screen';
import GridOnIcon from './divers/grid-on';
import GridIcon from './divers/grid';
import HomeIcon from './divers/home';
import HouseIcon from './divers/house';
import InfoOutlinedIcon from './divers/info-outlined';
import InfoIcon from './divers/info';
import LibraryBooksIcon from './divers/library-books';
import MapIcon from './divers/map';
import MenuIcon from './divers/menu';
import MoreVertIcon from './divers/more-vert';
import NatureIcon from './divers/nature';
import NotificationsActiveIcon from './divers/notification-active';
import PanoramaFishEyeIcon from './divers/panorama-fish-eye';
import PersonIcon from './divers/person';
import PhoneAndroidIcon from './divers/phone-android';
import PictureAsPdfIcon from './divers/picture-as-pdf';
import PlaylistAddIcon from './divers/play-list-add';
import QueryBuilderIcon from './divers/query-builder';
import ReceiptIcon from './divers/receipt';
import SearchIcon from './divers/search';
import SendIcon from './divers/send';
import ShoppingCartIcon from './divers/shopping-cart';
import SupervisorAccountIcon from './divers/supervisor-account';
import ThreeDRotationIcon from './divers/three-d-rotation';
import UnarchiveIcon from './divers/un-archive';
import ViewCompactIcon from './divers/view-compact';
import VisibilityOffIcon from './divers/visibility-off';
import VisibilityIcon from './divers/visibility';
import ArrowBackIcon from './divers/arrow-back';
import AccountIcon from './custom/account';
import AdministratifBlancIcon from './custom/administratif-blanc';
import AgendaIcon from './custom/agenda';
import AlignementCentreIcon from './custom/alignement-centre';
import AlignementDroiteIcon from './custom/alignement-droite';
import AlignementGaucheIcon from './custom/alignement-gauche';
import ArrowWhiteSortAscIcon from './custom/arrow-white-sort-asc';
import ArrowWhiteSortDescIcon from './custom/arrow-white-sort-desc';
import ArrowWhiteSortDisabledIcon from './custom/arrow-white-sort-disabled';
import AssistIcon from './custom/assist';
import BoldIcon from './custom/bold';
import CadenasIcon from './custom/cadenas';
import CalendarIcon from './custom/calender';
import CheckListIcon from './custom/checklist';
import ChevronIcon from './custom/chevron';
import ClientIcon from './custom/client';
import ConfettiIcon from './custom/confetti';
import ContactIcon from './custom/contact';
import CrossIcon from './custom/cross';
import DeconnexionIcon from './custom/deconnexion';
import DevisIcon from './custom/devis';
import DocIcon from './custom/doc';
import EnvoyerIcon from './custom/envoyer';
import FichierJPGIcon from './custom/fichier-jpg';
import FichierPDFIcon from './custom/fichier-pdf';
import FichierIcon from './custom/fichier';
import FixeIcon from './custom/fixe';
import FranceIcon from './custom/france';
import FuseeIcon from './custom/fusee';
import InfoOdooCrmIcon from './custom/info-odoo-crm';
import InstallationBlancIcon from './custom/installation-blanc';
import ItaliqueIcon from './custom/italique';
import LivraisonBlancIcon from './custom/livraison-blanc';
import LivraisonIcon from './custom/livraison';
import LoaderGreenIcon from './custom/loader-green';
import LoaderIcon from './custom/loader';
import LocalisationIcon from './custom/localisation';
import OffreIcon from './custom/offre';
import ParametreIcon from './custom/parametre';
import PlanningIcon from './custom/planning';
import ProjectIcon from './custom/project';
import SansPcBlancIcon from './custom/sans-pc-blanc';
import SignatureGreenIcon from './custom/signature-green';
import SouligneIcon from './custom/souligne';
import StatistiqueIcon from './custom/statistique';
import TacheIcon from './custom/tache';
import UserCheckInterfaceSymbolIcon from './custom/user-check-interface-symbol';
import WorksiteIcon from './custom/worksite';
import PhoneIcon from './divers/phone';
import GekaLogoBasicIcon from './logo/geka-logo-basic';
import LogoIcon from './logo/logo';
import LogoWhiteIcon from './logo/logo-white';
import LogoReduitIcon from './logo/logo-reduit';
import LogoReduitWhiteIcon from './logo/logo-reduit-white';
import LogoGreenkubIcon from './logo/logo-greenkub';
import LogoGreenkubWhiteIcon from './logo/logo-greenkub-white';
import LogoEcobriqueIcon from './logo/logo-ecobrique';
import GekaLogoWhiteNoBgIcon from './logo/geka-logo-white-no-bg';
import GekaLogoWhiteIcon from './logo/geka-logo-white-bg';
import GekaLogoGreenNoBgIcon from './logo/geka-logo-green-no-bg';
import Mail2Icon from './custom/mail';
import UsageIcon from './custom/usage';
import TriAlphabetiqueV3Icon from './custom/trie-alphabetique-v3';
import TriAlphabetiqueV2Icon from './custom/trie-alphabetique-v2';
import TriAlphabetiqueV1Icon from './custom/trie-alphabetique-v1';
import TelechargementIcon from './custom/telechargement';
import SurfaceParcelleV3Icon from './custom/surface-parcelle-v3';
import SurfaceParcelleV2Icon from './custom/surface-parcelle-v2';
import SurfaceParcelleV1Icon from './custom/surface-parcelle-v1';
import ResynchronisationIcon from './custom/resynchronisation';
import RealisationIcon from './custom/realisation';
import RapportTechniqueIcon from './custom/rapport-technique';
import PanierIcon from './custom/panier';
import LoupeIcon from './custom/loupe';
import InformationIcon from './custom/information';
import GeoportailV3Icon from './custom/geoportail-v3';
import GeoportailV2Icon from './custom/geoportail-v2';
import GeoportailV1Icon from './custom/geoportail-v1';
import EspaceDocumentaireIcon from './custom/espace-documentaire';
import EmployeeEnChargeIcon from './custom/employes-en-charge';
import DocPasIntegreIcon from './custom/doc-pas-integre';
import DocIntegreIcon from './custom/doc-integre';
import DepotMairieIcon from './custom/depot-mairie';
import DateIcon from './custom/date';
import DashbaordIcon from './custom/dashboard';
import CouleurTextIcon from './custom/couleur-texte';
import ConversationNotifIcon from './custom/conversation-notif';
import ChampagneIcon from './custom/champagne';
import AttentionIcon from './custom/attention';
import AlertIcon from './custom/alert';
import House2Icon from './custom/house';
import Mobile2Icon from './custom/mobile';
import GuideIcon from './custom/guide';
import FabFRIcon from './custom/fabFR';
import DeleteIcon from './divers/delete';
import AddGkIcon from './custom/add-gk';
import SuiviInstructionIcon from './custom/suivie-instruction';
import RetourIcon from './custom/retour';
import KozikazaV2Icon from './custom/kozikoza-v2';
import KozikazaV1Icon from './custom/kozikoza-v1';
import FleurIcon from './custom/fleur';
import CrossV3Icon from './custom/cross-v3';
import CrossV2Icon from './custom/cross-v2';
import CrossV1Icon from './custom/cross-v1';
import CompteIcon from './custom/compte';
import CheckV1Icon from './custom/check-v1';
import CheckV2Icon from './custom/check-v2';
import CheckV3Icon from './custom/check-v3';
import SignatureIcon from './custom/signature';
import ThumbUp from './divers/thumb-up';
import ChevronLeftIcon from './divers/chevron-left';

export enum IconColor {
  GRAY = 'GRAY',
  WHITE = 'WHITE',
  WHITE_BRIGHT = 'WHITE_BRIGHT',
  GREEN = 'GREEN',
  BLACK = 'BLACK',
}

export interface IconProps extends SVGProps<SVGSVGElement> {
  name: IconEnum | string;
  pathColor?: string;
  hoverable?: boolean;
  coloricon?: IconColor;
}
// export interface IconProps2
//   extends OverridableComponent<SvgIconTypeMap<{}, 'svg'>> {
//   name: IconEnum | string;
//   pathColor?: string;
//   hoverable?: boolean;
//   coloricon?: IconColor;
//   onAuxClick: any;
//   onClick: any;
//   style: any;
//   width: number;
//   height: number;
//   className: any;
// }

export function Icon(props: IconProps) {
  const formattedProps = { ...props };

  if (!formattedProps.onAuxClick) {
    formattedProps.onAuxClick = formattedProps.onClick;
  }

  if (!formattedProps.style) {
    formattedProps.style = { filter: '' };
  }

  /**
   * Gestion largeur
   */
  if (formattedProps.width) {
    formattedProps.height = undefined;
  } else {
    formattedProps.width = '40';
  }

  /**
   * Gestion hauteur
   */
  if (formattedProps.height) {
    formattedProps.width = undefined;
  }

  // formattedProps.viewBox = formattedProps.viewBox || '0 0 24 24';

  formattedProps.className = cx(
    styles['Icon'],
    (formattedProps.onClick || formattedProps.hoverable) && styles['Hoverable'],
    formattedProps.className
  );

  if (formattedProps.coloricon === IconColor.GRAY) {
    formattedProps.style.filter =
      'invert(40%) sepia(1%) saturate(1873%) hue-rotate(349deg) brightness(89%) contrast(93%)';
  } else if (formattedProps.coloricon === IconColor.WHITE) {
    formattedProps.style.filter =
      // 'invert(0%) sepia(0%) saturate(7500%) hue-rotate(139deg) brightness(91%) contrast(106%) brightness(0) saturate(100%)';
      'invert(0%) sepia(0%) saturate(7500%) hue-rotate(139deg) brightness(91%) contrast(106%)';
  } else if (formattedProps.coloricon === IconColor.WHITE_BRIGHT) {
    formattedProps.style.filter =
      'invert(0%) sepia(0%) saturate(7500%) hue-rotate(139deg) brightness(91%) contrast(106%) brightness(0) saturate(100%)';
  } else if (formattedProps.coloricon === IconColor.GREEN) {
    formattedProps.style.filter =
        'invert(63%) sepia(46%) saturate(686%) hue-rotate(91deg) brightness(96%) contrast(89%)';
  } else if (formattedProps.coloricon === IconColor.BLACK) {
    formattedProps.style.filter =
      'invert(0%) sepia(2%) saturate(6%) hue-rotate(314deg) brightness(96%) contrast(102%) brightness(0) saturate(100%)';
  }

  delete formattedProps.coloricon;

  switch (props.name) {
    // MENU
    case IconEnum.BASKET_TITLED:
      return <BasketTitledIcon {...formattedProps} />;
    case IconEnum.BUILD_RESERV_TITLED:
      return <BuildReservTitledIcon {...formattedProps} />;
    case IconEnum.CHAT_TITLED:
      return <ChatTitledIcon {...formattedProps} />;
    case IconEnum.CUSTOMER_NOTIFICATION:
      return <CustomerNotificationTitledIcon {...formattedProps} />;
    case IconEnum.DOCS_TITLED:
      return <DocsTitledIcon {...formattedProps} />;
    case IconEnum.EMPLOYEE_TITLED:
      return <EmployeeTitledIcon {...formattedProps} />;
    case IconEnum.FORM_TITLED:
      return <FormTitledIcon {...formattedProps} />;
    case IconEnum.INCIDENT_TITLED:
      return <IncidentTitledIcon {...formattedProps} />;
    case IconEnum.INFO_TITLED:
      return <InfoTitledIcon {...formattedProps} />;
    case IconEnum.PRODUCTION_PLANNING_TITLED:
      return <ProductionPlanningTitledIcon {...formattedProps} />;
    case IconEnum.QUOTE_TITLED:
      return <QuoteTitledIcon {...formattedProps} />;
    case IconEnum.SAV_TITLED:
      return <SavTitledIcon {...formattedProps} />;
    case IconEnum.TASK_TITLED:
      return <TaskTitledIcon {...formattedProps} />;
    case IconEnum.TRANSPORT_TITLED:
      return <TransportTitledIcon {...formattedProps} />;
    case IconEnum.VT_TITLED:
      return <VtTitledIcon {...formattedProps} />;
    case IconEnum.WORKSITE_PLANNING_TITLED:
      return <WorksitePlanningTitledIcon {...formattedProps} />;
    case IconEnum.WORKSITE_TITLED:
      return <WorksiteTitledIcon {...formattedProps} />;

    // DIVERS
    case IconEnum.ADD:
      return <AddIcon {...formattedProps} />;
    case IconEnum.ARCHIVE:
      return <ArchiveIcon {...formattedProps} />;
    case IconEnum.ARROW_BACK_IOS:
      return <ArrowBackIosIcon {...formattedProps} />;
    case IconEnum.ARROW_BACK:
      return <ArrowBackIcon {...formattedProps} />;
    case IconEnum.ARROW_DROP_DOWN:
      return <ArrowDropDownIcon {...formattedProps} />;
    case IconEnum.ARROW_DROP_UP:
      return <ArrowDropUpIcon {...formattedProps} />;
    case IconEnum.ARROW_FORWARD_IOS_ROUNDED:
      return <ArrowForwardIosRoundedIcon {...formattedProps} />;
    case IconEnum.ATTACH_FILE:
      return <AttachFileIcon {...formattedProps} />;
    case IconEnum.AUTO_RENEW:
      return <AutorenewIcon {...formattedProps} />;
    case IconEnum.BUILD:
      return <BuildIcon {...formattedProps} />;
    case IconEnum.CAST_CONNECTED:
      return <CastConnectedIcon {...formattedProps} />;
    case IconEnum.CHANGE_USER:
      return <ChangeUserIcon {...formattedProps} />;
    case IconEnum.CHECK_CIRCLE_OUTLINE:
      return <CheckCircleOutlineIcon {...formattedProps} />;
    case IconEnum.CHECK_CIRCLE:
      return <CheckCircleIcon {...formattedProps} />;
    case IconEnum.CHECK:
      return <CheckIcon {...formattedProps} />;
    case IconEnum.CHECKBOX_OUTLINED_BLANK:
      return <CheckBoxOutlineBlankIcon {...formattedProps} />;
    case IconEnum.CHECKBOX:
      return <CheckBoxIcon {...formattedProps} />;
    case IconEnum.CHEVRON_RIGHT:
      return <ChevronRightIcon {...formattedProps} />;
    case IconEnum.CHEVRON_LEFT:
      return <ChevronLeftIcon {...formattedProps} />;
    case IconEnum.CLOSE:
      return <CloseIcon {...formattedProps} />;
    case IconEnum.CREATE:
      return <CreateIcon {...formattedProps} />;
    case IconEnum.DELETE_FOREVER:
      return <DeleteForeverIcon {...formattedProps} />;
    case IconEnum.DELETE_OUTLINE_OUTLINED:
      return <DeleteOutlineOutlinedIcon {...formattedProps} />;
    case IconEnum.DELETE:
      return <DeleteIcon {...formattedProps} />;
    case IconEnum.DESCRIPTION:
      return <DescriptionIcon {...formattedProps} />;
    case IconEnum.DEVELOPER_BOARD:
      return <DeveloperBoardIcon {...formattedProps} />;
    case IconEnum.DNS:
      return <DnsIcon {...formattedProps} />;
    case IconEnum.DONE:
      return <DoneIcon {...formattedProps} />;
    case IconEnum.ECO:
      return <EcoIcon {...formattedProps} />;
    case IconEnum.EDIT_OUTLINED:
      return <EditOutlinedIcon {...formattedProps} />;
    case IconEnum.EDIT:
      return <EditIcon {...formattedProps} />;
    case IconEnum.ERROR_OUTLINED:
      return <ErrorOutlineIcon {...formattedProps} />;
    case IconEnum.EURO:
      return <EuroIcon {...formattedProps} />;
    case IconEnum.EVENT_AVAILABLE:
      return <EventAvailableIcon {...formattedProps} />;
    case IconEnum.EXIT_TO_APP:
      return <ExitToAppIcon {...formattedProps} />;
    case IconEnum.FAST_FORWARD:
      return <FastForwardIcon {...formattedProps} />;
    case IconEnum.FILE_COPY:
      return <FileCopyIcon {...formattedProps} />;
    case IconEnum.FOLDER:
      return <FolderIcon {...formattedProps} />;
    case IconEnum.FORMAT_LIST_BULLETED:
      return <FormatListBulletedIcon {...formattedProps} />;
    case IconEnum.FORUM:
      return <ForumIcon {...formattedProps} />;
    case IconEnum.FULL_SCREEN:
      return <FullscreenIcon {...formattedProps} />;
    case IconEnum.GRID_ON:
      return <GridOnIcon {...formattedProps} />;
    case IconEnum.GRID:
      return <GridIcon {...formattedProps} />;
    case IconEnum.HOME:
      return <HomeIcon {...formattedProps} />;
    case IconEnum.HOUSE2:
      return <House2Icon {...formattedProps} />;
    case IconEnum.INFO_OUTLINED:
      return <InfoOutlinedIcon {...formattedProps} />;
    case IconEnum.INFO:
      return <InfoIcon {...formattedProps} />;
    case IconEnum.LIBRARY_BOOKS:
      return <LibraryBooksIcon {...formattedProps} />;
    case IconEnum.MAIL:
      return <MailIcon {...formattedProps} />;
    case IconEnum.MAIL2:
      return <Mail2Icon {...formattedProps} />;
    case IconEnum.MAP:
      return <MapIcon {...formattedProps} />;
    case IconEnum.MENU:
      return <MenuIcon {...formattedProps} />;
    case IconEnum.MOBILE:
      return <MobileIcon {...formattedProps} />;
    case IconEnum.MORE_VERT:
      return <MoreVertIcon {...formattedProps} />;
    case IconEnum.NATURE:
      return <NatureIcon {...formattedProps} />;
    case IconEnum.NOTIFICATION_ACTIVE:
      return <NotificationsActiveIcon {...formattedProps} />;
    case IconEnum.PANORAMA_FISH_EYE:
      return <PanoramaFishEyeIcon {...formattedProps} />;
    case IconEnum.PERSON:
      return <PersonIcon {...formattedProps} />;
    case IconEnum.PHONE_ANDROID:
      return <PhoneAndroidIcon {...formattedProps} />;
    case IconEnum.PHONE:
      return <PhoneIcon {...formattedProps} />;
    case IconEnum.PICTURE_AS_PDF:
      return <PictureAsPdfIcon {...formattedProps} />;
    case IconEnum.PLACE:
      return <PlaceIcon {...formattedProps} />;
    case IconEnum.PLAY_LIST_ADD:
      return <PlaylistAddIcon {...formattedProps} />;
    case IconEnum.QUERY_BUILDER:
      return <QueryBuilderIcon {...formattedProps} />;
    case IconEnum.RECEIPT:
      return <ReceiptIcon {...formattedProps} />;
    case IconEnum.SEARCH:
      return <SearchIcon {...formattedProps} />;
    case IconEnum.SEND:
      return <SendIcon {...formattedProps} />;
    case IconEnum.SHOPPING_CART:
      return <ShoppingCartIcon {...formattedProps} />;
    case IconEnum.SUPERVISOR_ACCOUNT:
      return <SupervisorAccountIcon {...formattedProps} />;
    case IconEnum.THREE_D_ROTATION:
      return <ThreeDRotationIcon {...formattedProps} />;
    case IconEnum.UN_ARCHIVE:
      return <UnarchiveIcon {...formattedProps} />;
    case IconEnum.VIEW_COMPACT:
      return <ViewCompactIcon {...formattedProps} />;
    case IconEnum.VISIBILITY_OFF:
      return <VisibilityOffIcon {...formattedProps} />;
    case IconEnum.VISIBILITY:
      return <VisibilityIcon {...formattedProps} />;

    // LOGO
    case IconEnum.GEKA_LOGO_BASIC:
      return <GekaLogoBasicIcon {...formattedProps} />;
    case IconEnum.GEKA_LOGO_GREEN_NO_BG:
      return <GekaLogoGreenNoBgIcon {...formattedProps} />;
    case IconEnum.GEKA_LOGO_WHITE_BG:
      return <GekaLogoWhiteIcon {...formattedProps} />;
    case IconEnum.GEKA_LOGO_WHITE_NO_BG:
      return <GekaLogoWhiteNoBgIcon {...formattedProps} />;
    case IconEnum.LOCO_ECOBRIQUE:
      return <LogoEcobriqueIcon {...formattedProps} />;
    case IconEnum.LOGO_GREENKUB_WHITE:
      return <LogoGreenkubWhiteIcon {...formattedProps} />;
    case IconEnum.LOGO_GREENKUB:
      return <LogoGreenkubIcon {...formattedProps} />;
    case IconEnum.LOGO_REDUIT_WHITE:
      return <LogoReduitWhiteIcon {...formattedProps} />;
    case IconEnum.LOGO_REDUIT:
      return <LogoReduitIcon {...formattedProps} />;
    case IconEnum.LOGO_WHITE:
      return <LogoWhiteIcon {...formattedProps} />;
    case IconEnum.LOGO:
      return <LogoIcon {...formattedProps} />;

    // CUSTOM
    case IconEnum.ACCOUNT:
      return <AccountIcon {...formattedProps} />;
    case IconEnum.ADD_GK:
      return <AddGkIcon {...formattedProps} />;
    case IconEnum.ADMINISTRATIF_BLANC:
      return <AdministratifBlancIcon {...formattedProps} />;
    case IconEnum.AGENDA:
      return <AgendaIcon {...formattedProps} />;
    case IconEnum.ALERT:
      return <AlertIcon {...formattedProps} />;
    case IconEnum.ALIGNEMENT_CENTRE:
      return <AlignementCentreIcon {...formattedProps} />;
    case IconEnum.ALIGNEMENT_DROITE:
      return <AlignementDroiteIcon {...formattedProps} />;
    case IconEnum.ALIGNEMENT_GAUCHE:
      return <AlignementGaucheIcon {...formattedProps} />;
    case IconEnum.ARROW_WHITE_SORT_ASC:
      return <ArrowWhiteSortAscIcon {...formattedProps} />;
    case IconEnum.ARROW_WHITE_SORT_DESC:
      return <ArrowWhiteSortDescIcon {...formattedProps} />;
    case IconEnum.ARROW_WHITE_SORT_DISABLED:
      return <ArrowWhiteSortDisabledIcon {...formattedProps} />;
    case IconEnum.ASSIST:
      return <AssistIcon {...formattedProps} />;
    case IconEnum.ATTENTION:
      return <AttentionIcon {...formattedProps} />;
    case IconEnum.BOLD:
      return <BoldIcon {...formattedProps} />;
    case IconEnum.CADENAS:
      return <CadenasIcon {...formattedProps} />;
    case IconEnum.CALENDER:
      return <CalendarIcon {...formattedProps} />;
    case IconEnum.CHAMPAGNE:
      return <ChampagneIcon {...formattedProps} />;
    case IconEnum.CHECK_V1:
      return <CheckV1Icon {...formattedProps} />;
    case IconEnum.CHECK_V2:
      return <CheckV2Icon {...formattedProps} />;
    case IconEnum.CHECK_V3:
      return <CheckV3Icon {...formattedProps} />;
    case IconEnum.CHECK2:
      return <CheckIcon {...formattedProps} />;
    case IconEnum.CHECKLIST:
      return <CheckListIcon {...formattedProps} />;
    case IconEnum.CHEVRON:
      return <ChevronIcon {...formattedProps} />;
    case IconEnum.CLIENT:
      return <ClientIcon {...formattedProps} />;
    case IconEnum.COMPTE:
      return <CompteIcon {...formattedProps} />;
    case IconEnum.CONFETTI:
      return <ConfettiIcon {...formattedProps} />;
    case IconEnum.CONTACT:
      return <ContactIcon {...formattedProps} />;
    case IconEnum.CONVERSATION_NOTIF:
      return <ConversationNotifIcon {...formattedProps} />;
    case IconEnum.COULEUR_TEXT:
      return <CouleurTextIcon {...formattedProps} />;
    case IconEnum.CROSS_V1:
      return <CrossV1Icon {...formattedProps} />;
    case IconEnum.CROSS_V2:
      return <CrossV2Icon {...formattedProps} />;
    case IconEnum.CROSS_V3:
      return <CrossV3Icon {...formattedProps} />;
    case IconEnum.CROSS:
      return <CrossIcon {...formattedProps} />;
    case IconEnum.DASHBOARD:
      return <DashbaordIcon {...formattedProps} />;
    case IconEnum.DATE:
      return <DateIcon {...formattedProps} />;
    case IconEnum.DECONNEXION:
      return <DeconnexionIcon {...formattedProps} />;
    case IconEnum.DEPOT_MAIRIE:
      return <DepotMairieIcon {...formattedProps} />;
    case IconEnum.DEVIS:
      return <DevisIcon {...formattedProps} />;
    case IconEnum.DOC_INTEGRE:
      return <DocIntegreIcon {...formattedProps} />;
    case IconEnum.DOC_PAS_INTEGRE:
      return <DocPasIntegreIcon {...formattedProps} />;
    case IconEnum.DOC:
      return <DocIcon {...formattedProps} />;
    case IconEnum.EMPLOYEE_EN_CHARGE:
      return <EmployeeEnChargeIcon {...formattedProps} />;
    case IconEnum.ENVOYER:
      return <EnvoyerIcon {...formattedProps} />;
    case IconEnum.ESPACE_DOCUMENTAIRE:
      return <EspaceDocumentaireIcon {...formattedProps} />;
    case IconEnum.FICHIER_JPG:
      return <FichierJPGIcon {...formattedProps} />;
    case IconEnum.FICHIER_PDF:
      return <FichierPDFIcon {...formattedProps} />;
    case IconEnum.FICHIER:
      return <FichierIcon {...formattedProps} />;
    case IconEnum.FIXE:
      return <FixeIcon {...formattedProps} />;
    case IconEnum.FLEUR:
      return <FleurIcon {...formattedProps} />;
    case IconEnum.FRANCE:
      return <FranceIcon {...formattedProps} />;
    case IconEnum.FUSEE:
      return <FuseeIcon {...formattedProps} />;
    case IconEnum.GEOPORTAIL_V1:
      return <GeoportailV1Icon {...formattedProps} />;
    case IconEnum.GEOPORTAIL_V2:
      return <GeoportailV2Icon {...formattedProps} />;
    case IconEnum.GEOPORTAIL_V3:
      return <GeoportailV3Icon {...formattedProps} />;
    case IconEnum.HOUSE:
      return <HouseIcon {...formattedProps} />;
    case IconEnum.INFO_ODOO_CRM:
      return <InfoOdooCrmIcon {...formattedProps} />;
    case IconEnum.INFORMATION:
      return <InformationIcon {...formattedProps} />;
    case IconEnum.INSTALLATION_BLANC:
      return <InstallationBlancIcon {...formattedProps} />;
    case IconEnum.ITALIQUE:
      return <ItaliqueIcon {...formattedProps} />;
    case IconEnum.KOZIKAZA_V1:
      return <KozikazaV1Icon {...formattedProps} />;
    case IconEnum.KOZIKAZA_V2:
      return <KozikazaV2Icon {...formattedProps} />;
    case IconEnum.LIVRAISON_BLANC:
      return <LivraisonBlancIcon {...formattedProps} />;
    case IconEnum.LIVRAISON:
      return <LivraisonIcon {...formattedProps} />;
    case IconEnum.LOADER_GREEN:
      return <LoaderGreenIcon {...formattedProps} />;
    case IconEnum.LOADER:
      return <LoaderIcon {...formattedProps} />;
    case IconEnum.LOCALISATION:
      return <LocalisationIcon {...formattedProps} />;
    case IconEnum.LOUPE:
      return <LoupeIcon {...formattedProps} />;
    case IconEnum.MOBILE2:
      return <Mobile2Icon {...formattedProps} />;
    case IconEnum.OFFRE:
      return <OffreIcon {...formattedProps} />;
    case IconEnum.PANIER:
      return <PanierIcon {...formattedProps} />;
    case IconEnum.PARAMETRE:
      return <ParametreIcon {...formattedProps} />;
    case IconEnum.PLANNING:
      return <PlanningIcon {...formattedProps} />;
    case IconEnum.PROJECT:
      return <ProjectIcon {...formattedProps} />;
    case IconEnum.RAPPORT_TECHNIQUE:
      return <RapportTechniqueIcon {...formattedProps} />;
    case IconEnum.REALISATION:
      return <RealisationIcon {...formattedProps} />;
    case IconEnum.RESYNCHRONISATION:
      return <ResynchronisationIcon {...formattedProps} />;
    case IconEnum.RETOUR:
      return <RetourIcon {...formattedProps} />;
    case IconEnum.SANS_PC_BLANC:
      return <SansPcBlancIcon {...formattedProps} />;
    case IconEnum.SIGNATURE:
      return <SignatureIcon {...formattedProps} />;
    case IconEnum.SIGNATURE_GREEN:
      return <SignatureGreenIcon {...formattedProps} />;
    case IconEnum.SOULIGNE:
      return <SouligneIcon {...formattedProps} />;
    case IconEnum.STATISTIQUE:
      return <StatistiqueIcon {...formattedProps} />;
    case IconEnum.SUIVIE_INSTRUCTION:
      return <SuiviInstructionIcon {...formattedProps} />;
    case IconEnum.SURFACE_PARCELLE_V1:
      return <SurfaceParcelleV1Icon {...formattedProps} />;
    case IconEnum.SURFACE_PARCELLE_V2:
      return <SurfaceParcelleV2Icon {...formattedProps} />;
    case IconEnum.SURFACE_PARCELLE_V3:
      return <SurfaceParcelleV3Icon {...formattedProps} />;
    case IconEnum.TACHE:
      return <TacheIcon {...formattedProps} />;
    case IconEnum.TELECHARGEMENT:
      return <TelechargementIcon {...formattedProps} />;
    case IconEnum.TELEPHONE:
      return <PhoneIcon {...formattedProps} />;
    case IconEnum.TRIE_ALPHABETIQUE_V1:
      return <TriAlphabetiqueV1Icon {...formattedProps} />;
    case IconEnum.TRIE_ALPHABETIQUE_V2:
      return <TriAlphabetiqueV2Icon {...formattedProps} />;
    case IconEnum.TRIE_ALPHABETIQUE_V3:
      return <TriAlphabetiqueV3Icon {...formattedProps} />;
    case IconEnum.USAGE:
      return <UsageIcon {...formattedProps} />;
    case IconEnum.USER_CHECK_INTERFACE_SYMBOL:
      return <UserCheckInterfaceSymbolIcon {...formattedProps} />;
    case IconEnum.WORKSITE:
      return <WorksiteIcon {...formattedProps} />;
    case IconEnum.GUIDE:
      return <GuideIcon {...formattedProps} />;
    case IconEnum.FAB_FR:
      return <FabFRIcon {...formattedProps} />;
    case IconEnum.THUMB_UP:
      return <ThumbUp {...formattedProps} />;
    default:
      return null;
  }
}

export default Icon;
